// AIReportComponent.js (no optional chaining, safe for older builds)

import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Typography from "@material-ui/core/Typography";
import { Loading } from "../LoadingComponent";
import MotComponent from "./MotComponent";

// Icons
import AssessmentRoundedIcon from "@material-ui/icons/AssessmentRounded";
import AssignmentRoundedIcon from "@material-ui/icons/AssignmentRounded";
import HistoryRoundedIcon from "@material-ui/icons/HistoryRounded";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import ThumbUpRoundedIcon from "@material-ui/icons/ThumbUpRounded";
import { DEFAULT_CHECK_PRICE, fetchCheckPrice, formatPrice } from "../../shared/pricing";
import "../HomeSections.css";

export default function AIReportComponent(props) {
  const [notification, setNotification] = useState("");
  const [report, setReport] = useState(null);
  const [checkPrice, setCheckPrice] = useState(DEFAULT_CHECK_PRICE);

  useEffect(() => {
    let active = true;
    fetchCheckPrice().then(price => {
      if (active) setCheckPrice(price);
    });
    return () => { active = false; };
  }, []);

  const q =
    props && props.match && props.match.params && props.match.params.q
      ? props.match.params.q
      : "";


  useEffect(() => {
    setReport(null);
    if (props.getAIReport) props.getAIReport(q);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  useEffect(() => {
    if (props.getAIReportLoader) {
      setReport(null);
      setNotification("Loading the report...");
    } else if (props.getAIReportSuccess) {
      setReport(props.getAIReportSuccess);
      setNotification("");
    } else if (props.getAIReportError) {
      setNotification("Report not found");
    }
  }, [props.getAIReportLoader, props.getAIReportSuccess, props.getAIReportError]);

  const goToPremium = () => {
    // Adjust if your premium flow uses a different URL
    if (props.history && props.history.push) {
      props.history.push(
        `/guest-checkout?reg=${encodeURIComponent(q)}&source=ai`
      );
    }
  };

  // Safe reads without optional chaining
  const customerPerspective =
    report && report.customer_perspective ? report.customer_perspective : null;

  const caution = customerPerspective && customerPerspective.caution ? customerPerspective.caution : "";
  const positive = customerPerspective && customerPerspective.positive ? customerPerspective.positive : "";
  const recommendation =
    customerPerspective && customerPerspective.recommendation ? customerPerspective.recommendation : "";

  const goodPoints = report && report.good_points ? report.good_points : [];
  const badPoints = report && report.bad_points ? report.bad_points : [];
  const motData = report && report.mot_data ? report.mot_data : [];

  return (
    <div>
      <Helmet>
        <meta name="description" content="AI Vehicle Insights" />
        <title>Reg Check Mate - UK</title>
      </Helmet>

      <section className="gen-section filter_space">
        <div
          className="container mobile_padding"
          style={{ paddingTop: "40px", paddingBottom: "120px" }}
        >
          <div className="row">
            <div className="col-lg-12 col-sm-12">
              {/* Loader */}
              {props.getAIReportLoader && (
                <div>
                  <Loading />
                </div>
              )}

              {/* Error Message */}
              {props.getAIReportError && (
                <div style={{ marginTop: 20 }}>
                  <Card style={{ borderRadius: 14 }}>
                    <CardBody>
                      <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                        Error
                      </Typography>
                      <Typography variant="body2">
                        {String(props.getAIReportError)}
                      </Typography>
                    </CardBody>
                  </Card>
                </div>
              )}

              {/* Report Content */}
              {report && (
                <div>
                  {/* Header: plate, what this is, and the next step */}
                  <div className="rc-ai-header">
                    <div className="rc-ai-header-copy">
                      <span className="report-plate">{q}</span>
                      <h1>AI MOT insights</h1>
                      <p>
                        What this vehicle&rsquo;s MOT record suggests, read for
                        you. This is a free summary of test history only.
                      </p>
                    </div>
                    <div className="rc-ai-header-cta">
                      <div className="rc-upsell-price">{formatPrice(checkPrice)}</div>
                      <div className="rc-upsell-note">full vehicle history</div>
                      <Button className="rc-cta" onClick={goToPremium}>
                        Get the full check
                      </Button>
                      <p className="rc-reassure" style={{ marginTop: 8 }}>
                        Finance, stolen, write-off and mileage checks
                      </p>
                    </div>
                  </div>

                  {/* AI MOT Insights */}
                  {/*<SectionTitle*/}
                  {/*  icon={<AssessmentRoundedIcon style={{ fontSize: 26 }} />}*/}
                  {/*  title="AI MOT Insights"*/}
                  {/*/>*/}
                  <Typography variant="h6" className="rc-ai-heading">
                    <AssessmentRoundedIcon style={{ fontSize: 26 }} />  AI MOT Insights
                  </Typography>

                  <Card
                    style={{
                      borderRadius: 14,
                      border: "none",
                      boxShadow: "0 10px 26px rgba(0,0,0,0.06)",
                    }}
                  >
                    <CardBody>
                      {/*Cautionary Notes:*/}
                      <Row
                        className="rc-note rc-note--warn"
                        style={{
                          borderRadius: 12,
                          padding: "12px 14px",
                          margin: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <WarningRoundedIcon style={{ marginTop: 2, color: 'black' }} />
                          <Typography variant="subtitle2" className="ai-insight-text">
                            {caution}
                          </Typography>
                        </div>
                      </Row>

                      <div style={{ height: 16 }} />

                      {/*Good Points:*/}
                      <Row
                        className="rc-note rc-note--good"
                        style={{
                          borderRadius: 16,
                          padding: "12px 14px",
                          margin: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <ThumbUpRoundedIcon style={{ marginTop: 2 }} />
                          <Typography variant="subtitle2" className="ai-insight-text">
                            {positive}
                          </Typography>
                        </div>
                      </Row>

                      <div style={{ height: 16 }} />

                      {/*Next Steps Recommendation:*/}
                      <Row
                        className="rc-note rc-note--info"
                        style={{
                          borderRadius: 12,
                          padding: "12px 14px",
                          margin: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <StarRoundedIcon style={{ marginTop: 2 }} />
                          <Typography variant="subtitle2" className="ai-insight-text">
                            {recommendation}
                          </Typography>
                        </div>
                      </Row>
                    </CardBody>
                  </Card>

                  <div style={{ height: 40 }} />

                  {/* AI Insights Details */}
                  {/*<SectionTitle*/}
                  {/*  icon={<AssignmentRoundedIcon style={{ fontSize: 26 }} />}*/}
                  {/*  title="AI Insights Details"*/}
                  {/*/>*/}
                  <Typography variant="h6" className="rc-ai-heading">
                    <AssignmentRoundedIcon style={{ fontSize: 26 }} />  AI Insights Details
                  </Typography>

                  <Row>
                    <Col>
                      <Card
                        style={{
                          borderRadius: 14,
                          border: "none",
                          boxShadow: "0 10px 26px rgba(0,0,0,0.06)",
                          height: "100%",
                        }}
                      >
                        <CardBody>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 800, marginBottom: 24 }}
                          >
                            Positive signals
                          </Typography>

                          {goodPoints.map((point, index) => (
                            <div key={"good-" + index} style={{ marginBottom: 10 }}>
                              <Row
                                className="rc-note rc-note--good"
                                style={{
                                  borderRadius: 12,
                                  padding: "10px 12px",
                                  margin: 0,
                                }}
                              >
                                <Typography className="ai-text" variant="subtitle2">
                                  {point}
                                </Typography>
                              </Row>
                            </div>
                          ))}
                        </CardBody>
                      </Card>
                    </Col>

                    <Col>
                      <Card
                        style={{
                          borderRadius: 14,
                          border: "none",
                          boxShadow: "0 10px 26px rgba(0,0,0,0.06)",
                          height: "100%",
                        }}
                      >
                        <CardBody>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 800, marginBottom: 24 }}
                          >
                            Things to watch
                          </Typography>

                          {badPoints.map((point, index) => (
                            <div key={"bad-" + index} style={{ marginBottom: 10 }}>
                              <Row
                                className="rc-note rc-note--warn"
                                style={{
                                  borderRadius: 12,
                                  padding: "10px 12px",
                                  margin: 0,
                                }}
                              >
                                <Typography className="ai-text" variant="subtitle2">
                                  {point}
                                </Typography>
                              </Row>
                            </div>
                          ))}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <div style={{ height: 40 }} />

                  {/* MOT History */}
                  {/*<SectionTitle*/}
                  {/*  icon={<HistoryRoundedIcon style={{ fontSize: 26 }} />}*/}
                  {/*  title="MOT History"*/}
                  {/*/>*/}
                  <Typography variant="h6" className="rc-ai-heading">
                    <HistoryRoundedIcon style={{ fontSize: 26 , color: 'black'}} />  MOT History
                  </Typography>

                  <Card
                    style={{
                      borderRadius: 14,
                      border: "none",
                      boxShadow: "0 10px 26px rgba(0,0,0,0.06)",
                    }}
                  >
                    <CardBody>
                      <Row>
                        {motData.map((d, i) => (
                          <div key={i} className="mot-component-container">
                            <MotComponent d={d} i={i} />
                          </div>
                        ))}
                      </Row>
                    </CardBody>
                  </Card>

                  {notification ? (
                    <div style={{ marginTop: 16 }}>
                      <Typography variant="caption">{notification}</Typography>
                    </div>
                  ) : null}
                </div>
              )}

              {/* Default state */}
              {!props.getAIReportLoader &&
                !props.getAIReportError &&
                !props.getAIReportSuccess && (
                  <div style={{ marginTop: 20 }}>
                    <Card style={{ borderRadius: 14 }}>
                      <CardBody>
                        <Typography variant="body2">Getting the report...</Typography>
                      </CardBody>
                    </Card>
                  </div>
                )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
